/**
 * Page load event target constants
 *
 * This file serves as documentation of all the page laod targets that can be used for filtering
 * in the Observability Tool. Each constant represents a unique page or UI element that
 * can be tracked via telemetry events.
 *
 * Observability Tool Filtering:
 * You can filter event logs in the Observability Tool using the metadata target values.
 * Example filter: Event Name = 'PAGE_LOAD' AND Metadata Target = 'entity-dashboard'
 *
 * @example
 * import { useTrackEvent } from 'hooks/useTrackEvent';
 * import { PageLoadsTargets } from 'constants/pageLoadTargets';
 * const { trackPageLoad } = useTrackEvent({ tenant, product: 'IEM' });
 * trackPageLoad(PageLoadsTargets.EntityDashboard);
 */

export const PageLoadsTargets = {
	//Pages
	MyDay: 'my-day',
	EntityDashboard: 'entity-dashboard',
	RaiseDashboard: 'raise-dashboard',
	AlertCenter: 'alert-center',
	NewAlertReport: 'new-alert-pick-report',
	NewAlertAnalysis: 'new-alert-analysis',
	Settings: 'settings',
	LP360: 'lp360',
	WorkQueue: 'work-queue',
	AllLPs: 'all-lps',

	// Drawers
	TaskDrawer: 'task-drawer',
	AlertDrawer: 'alert-drawer',
	FundraisingDrawer: 'fundraising-drawer',
  EntityDrawer: 'entity-drawer',
	FeedbackDrawer: 'feedback-drawer',
	HealthSignalDrawer: 'health-signal-drawer',
	DraftOutreachDrawer: 'draft-outreach-drawer',
};
